import React, { useState } from 'react';
import { ObjectManager } from '../../../concepts/objects';
import { Icon } from '../../../concepts/resources/Icon';
import { Menu } from '../../../ui';
import { PropertyFacade } from '../../canvas/properties/PropertyFacade';
import { PopoutWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { useResolve } from '../../Container';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { Tray } from './Tray';
import { TrayMode, TrayModeOption } from './TrayMode';

export const TrayMenuWidget = ({ widget }: { widget: PopoutWidget }) => {

    const facade = widget.facade as PropertyFacade<Tray>;

    const objects = useResolve(ObjectManager);
    const [mode, setMode] = useState(facade.get('mode') || 'none');

    const onSetMode = (value: TrayMode) => {
        setMode(value);
        objects.update(u => {
            u.set('key', facade.keyFor('mode'));
            facade.set('mode', value);
        });
        widget.update({
            text: TrayModeOption.get(value)?.label ?? 'None',
        });
    };

    return <Flexer width="16">
        <Menu>
            {TrayModeOption.all.map(option => (
                <Menu.Item key={option.mode} onClick={() => onSetMode(option.mode)}>
                    <Menu.ItemText>{option.label}</Menu.ItemText>
                    <Menu.ItemPush>
                        {mode === option.mode && <Icon size="1.25" src="deqo://icons/hero/check" />}
                    </Menu.ItemPush>
                </Menu.Item>
            ))}
        </Menu>
    </Flexer>;
};
